export const ADD_MEMBER = "/fund/add_member/";
export const DELETE_MEMBER = "/fund/delete_member/";
export const EDIT_MEMBER = "/fund/edit_member/";
export const EDIT_DIRECTOR_ID = "/fund/edit_member/";
